// src/pages/B2B/event-reports/components/ReportPreviewPanel.tsx
import React from 'react';
import { formatTzWindow } from '../utils/formatTzWindow';
import type { BuilderFormState } from '../types';

interface Props {
  form: BuilderFormState;
}

export function ReportPreviewPanel({ form }: Props): React.ReactElement {
  const window = formatTzWindow(form.from_local, form.to_local, form.timezone);
  const title = form.event_name || 'Event Recap';
  const location = form.location_label || form.timezone.split('/').pop()?.replace(/_/g, ' ');

  return (
    <div className="rounded-2xl overflow-hidden border border-gray-800 bg-[#0a0a14] aspect-[8.5/11] relative shadow-xl">
      {form.image_preview_url ? (
        <img
          src={form.image_preview_url}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : null}
      <div
        className="absolute inset-0"
        style={{
          background: form.image_preview_url
            ? 'linear-gradient(180deg, rgba(10,10,20,0.15) 0%, rgba(10,10,20,0.65) 70%, #0a0a14 100%), linear-gradient(135deg, rgba(124,58,237,0.55) 0%, rgba(236,72,153,0.35) 100%)'
            : 'linear-gradient(135deg, #7c3aed 0%, #ec4899 60%, #fb923c 100%)',
        }}
      />
      <div className="relative h-full flex flex-col justify-between p-6 text-white">
        <div className="text-[10px] tracking-[0.3em] uppercase font-bold opacity-90">
          SocialSpark
        </div>
        <div>
          <div className="text-[10px] tracking-[0.25em] uppercase opacity-85">Event Recap</div>
          <div className="text-3xl font-extrabold leading-tight mt-1">{title}</div>
          <div className="text-xs opacity-85 mt-1">
            {window || 'Set date, time, and timezone'}
          </div>
          {location && (
            <div className="text-xs opacity-70 mt-1">{location}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReportPreviewPanel;
